export const API_BLOG = process.env.REACT_APP_API_BLOG || 'https://dev-api.mondplan.nl';
